<div #content [class.pz-dragging]="isDragging">
    <ng-content></ng-content>
</div>
@if (zoomButton && !isTouchScreen) {
    <div class="pz-zoom-button" (click)="toggleZoom()" [class.pz-zoom-out]="scale > 1"></div>
}
